/**
 * Browser-safe Google OAuth settings. Values come from Vite env at **build** time.
 *
 * Never put `GOOGLE_CLIENT_SECRET` here or in any `VITE_*` variable. It must only run on a backend
 * (Lambda) when you add the API. GitHub: store the secret as `GOOGLE_CLIENT_SECRET` and inject it
 * into server-side config only.
 */
export const googleOAuth = {
  clientId: import.meta.env.VITE_GOOGLE_CLIENT_ID?.trim() ?? "",
  redirectUri:
    import.meta.env.VITE_GOOGLE_REDIRECT_URI?.trim() ||
    "https://code.msleonard.com/auth/callback/google",
} as const;

/** Base URL for the HTTP API (no trailing slash), e.g. https://abc123.execute-api.us-west-2.amazonaws.com */
export const apiBaseUrl = import.meta.env.VITE_API_BASE_URL?.trim() ?? "";

/** WebSocket URL for teacher live cohort activity (no trailing slash). */
export const liveWsUrl = import.meta.env.VITE_LIVE_WS_URL?.trim() ?? "";

export function isGoogleOAuthConfigured(): boolean {
  return googleOAuth.clientId.length > 0;
}

export function isApiConfigured(): boolean {
  return apiBaseUrl.length > 0;
}

export function isLiveWsConfigured(): boolean {
  return liveWsUrl.length > 0;
}
